module.exports = __webpack_public_path__ + "img/documentary.a66022d2.jpg";